import {Module} from 'vuex';
import detail from "@/js/detail";

/**
 * 方案书模块
 * @type { Module }
 */
export const proposalProject = {
    namespaced: true,
    state: {
        // 方案书详情对象
        plantDetail: {},
        // 项目详情数据
        projectDetail: {},
    },
    mutations: {
        // 保存方案书详情
        CHANGE_PLANT: (state, typeAction) => {
            state.plantDetail = typeAction.plantDetail;
            // console.log(typeAction.projectDetail,'detail');
            state.projectDetail = typeAction.projectDetail;
        },
    },
    actions: {
        /**
         * 请求方案书详情数据
         * @param commit
         * @param state
         * @param typePayload
         * @return {Promise<void>}
         */
        fetchPlantDetail: async ({commit, state, dispatch}, typePayload = {}) => {
            const {result: projectDetail} = await detail.getProjectInfoV2({project_id: typePayload.id,ut_source:typePayload.ut_source});

            const reportData = {
                report_id: projectDetail.wind_report_id,
                show_sub: 1, //子报告
                show_room: 1, //房间信息
                show_attach: 1, //附件信息
                show_product_type: 1, //产品类型
                show_product: 1, //方案商品
                show_tag: 1, //标签信息
                show_common: 1, //通用信息
                init_room: 1, // 初始信息
                chunk_room_product: 1, //房间数量是否根据风盘拆分
                show_card: 1, //获取名片
                qr_code: 1, //转化二维码
                is_edit: 0,
            };
            const {result: plantDetail} = await detail.getReportinfo(reportData);
            // console.log(JSON.parse(JSON.stringify(projectDetail.items)))

            commit({type: 'CHANGE_PLANT', plantDetail, projectDetail});
            await dispatch({type: 'projectDetailCustom/mapCustomerInfo'}, {root: true});
        },
    },
    getters: {
        /**
         * 方案书基本信息
         * @param state
         * @return {function(): {}}
         */
        basicInfo: (state) => () => {
            const {
                // 地址
                address,
                // 房屋面积
                area,
                // 楼高
                floor,
                // 外墙保温
                warm_keep,
                // 隔热窗
                warm_length,
                // 房屋类型
                house_type,
                // 配置标签
                tags,
                // 楼层信息
                sub,
                // 对标索引
                compare_id,
                // 家庭人员
                config_num,
            } = state.plantDetail;
            // 家庭情况标签
            let personTag = tags.find(i => i.type === 2);
            personTag = personTag.items.map(i => i.name);
            // 性别
            const sex = personTag.includes('先生') ? '先生' : '女士';

            // 作息需求标签
            let timeTag = tags.find(i => i.type === 1);
            timeTag = timeTag.items.map(i => i.name);

            // 个性需求
            let demandTag = tags.find(i => i.type === 3);
            demandTag = demandTag.items.map(i => i.name);

            return {
                address,
                area,
                floor,
                warm_keep,
                warm_length,
                house_type,
                sex,
                sub,
                compare_id,
                config_num,
                personTag,
                timeTag,
                demandTag
            }
        },
        /**
         * 选型配置
         */
        selectionInfo: (state) => () => {
            const {
                // 楼层信息
                sub
            } = state.plantDetail;
            return {sub};
        },
        /**
         * 报告附件资料
         * @param state
         * @return {function(): {}}
         */
        plantSub: (state) => () => {
            const {
                plantDetail: {
                    // 报告附件
                    attach,
                    // 三维图
                    third_img_url
                }
            } = state;
            return {attach, third_img_url}
        }
    }
}
